<template>
  <div>
    <gmap-info-window
      :options="infoOptions"
      :position="infoWindowPos"
      :opened="infoWinOpen"
      @closeclick="$emit('close')"
    >
      <div id="content">
        <div
          class="myContent"
          :style="`background-color: ${bgcolor}`"
        >
        <span class="title-card-map">
          {{ title }}
        </span>
        </div>
        <div
          id="bodyContent"
          style="padding: 0 3rem;"
        >
          <table style="width:100%;">
            <tr
              v-for="(field, index) in Object.keys(infoContent.content)"
              :key="index"
            >
              <td
                class="text-right"
                style="max-width: 25%"
              ><strong>{{field}}</strong></td>
              <td>{{infoContent.content[field]}}</td>
            </tr>
          </table>
          <div v-if="infoContent.hasOwnProperty('images')">
            <div>
              <h5><strong>Galeria: </strong></h5>
            </div>
            <div v-if="infoContent.images">
              <div class="d-flex flex-wrap justify-content-around row">
                <div
                  v-for="(image, i) in infoContent.images" :key="i"
                  @click="openImgModal({index: i, src: image})"
                  class="col-lg-3"
                  style="margin-bottom: 10px"
                >
                  <img
                    class="image"
                    :src="image"
                  >
                </div>
              </div>

            </div>
            <div v-else>
              <p style="text-align:center">Este evento não possui fotos.</p>
            </div>
          </div>
        </div>
      </div>
    </gmap-info-window>
  </div>

</template>

<script>
  import {VueAgile} from 'vue-agile'
  import GalleryComponent from 'src/components/GalleryComponent'
  import {mapActions} from 'vuex'

  export default {
    name: 'InfoContentGmap',
    components: {
      GalleryComponent,
      VueAgile
    },
    props: ['infoWinOpen', 'infoContent', 'bgcolor', 'title', 'infoWindowPos'],
    data () {
      return {
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        modalSrc: '',
        showModal: false,
        index: 0,
        asNavFor1: [],
        asNavFor2: [],
        options1: {
          dots: false,
          fade: true,
          navButtons: false
        },
        options2: {
          autoplay: true,
          centerMode: true,
          dots: false,
          navButtons: false,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 1000,
              settings: {
                navButtons: true
              }
            }
          ]
        }
      }
    },
    methods: {
      ...mapActions('gallery', ['defineGallery']),
      openImgModal ({index, src}) {
        this.$emit('openModalDashboard', {index, src, infoContent: this.infoContent})
        this.defineGallery({show: true, images: this.infoContent.images, index})
      }
    },
    mounted () {
      this.asNavFor1.push(this.$refs.thumbnails)
      this.asNavFor2.push(this.$refs.main)
    }
  }
</script>

<style scoped>
  #content {
    margin-right: 10px;
  }

  .myContent {
    padding: 12px 100px;
    border-radius: 8px;
    margin-bottom: 16px;
    text-align: center;
  }

  .title-card-map {
    font-size: 20pt;
  }

  table {
    text-wrap: normal;
  }

  td {
    padding: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Trg/Dashboard/InfoContentGmap.vue